import { useMutation, useQuery } from 'react-query';

import { FormActions, NotificationPosition } from 'coreOld/enums';
import { useInfiniteQuery, useHandleErrors } from 'coreOld/hooks';
import { actionLoadingMessage, actionMessage } from 'coreOld/utils';
import { costingService } from 'partsOld/services';
import { ICost } from 'partsOld/types';

export const useGetCostingList = (filters?) =>
  useInfiniteQuery<ICost>(costingService.getMany, 'costingList', filters);

export const useGetActiveOverlappingCost = (queryParams?) => {
  const { data, isError, isLoading, refetch } = useQuery(
    ['activeOverlapping', queryParams],
    () => costingService.getActiveOverlappingCost(queryParams),
    {
      keepPreviousData: true,
      enabled: false,
    }
  );

  return {
    record: data?.record ?? null,
    isError,
    isLoading,
    refetch,
  };
};

export const useCostingActions = () => ({
  ...useUpsertCost(),
  ...useRemoveCost(),
});

const useUpsertCost = () => {
  const { errors } = useHandleErrors(
    actionMessage('Part cost'),
    actionLoadingMessage('part cost'),
    NotificationPosition.MODAL,
    ['costingList'],
    FormActions.UPSERT
  );

  const { mutateAsync } = useMutation(costingService.upsertCost, {
    ...errors,
  });

  const upsertCost = (data) => mutateAsync(data);

  return { upsertCost };
};

const useRemoveCost = () => {
  const { errors } = useHandleErrors(
    actionMessage('Part cost'),
    actionLoadingMessage('part cost'),
    NotificationPosition.MODAL,
    ['costingList'],
    FormActions.REMOVE
  );

  const { mutateAsync, isLoading, isSuccess } = useMutation(costingService.removeCost, {
    ...errors,
  });

  const removeCost = (data) => mutateAsync(data);

  return { removeCost, isLoading, isSuccess };
};
